import React from 'react'
import styled from 'styled-components'
import { Block, Spinner, Text } from '@mote/ui'
import { Hint, textDefaultProps } from './RecorderText'

export const Loader = ({
  title,
  hint = '(You can move this window around)'
}) => (
  <Block align='center' justify='center' spreadY spreadX>
    <Spinner radius={100} color='#AC0AE8' duration={1400} strokeWidth={3} />

    {title && (
      <Text {...textDefaultProps} styles={{ marginTop: '32px' }}>
        {title}
      </Text>
    )}
    {hint && <Hint style={{ marginTop: '8px' }}>{hint}</Hint>}
  </Block>
)
